export default __webpack_public_path__ + "static/boy-c55af4b8b626b115c24f604dc83633cb.svg";